import React, { Component, Fragment } from "react";
import autoBind from "react-autobind";
import Address from "@common/components/address/components/address.component";
import { Row, Col } from "react-bootstrap";
import DDados from "../contadorContribuinte.ddados";
import DDadosItem from "@common/components/ddados/ddados.item";
import { connect } from "@common/components/base.component";
import contadorActions from "../store/contador.actions";
import contadorSelector from "../store/contador.selectors";
import Panel from '@common/components/panel/panel.component';
import CpfCnpjValidator from '@common/validators/cpfCnpj.validator';
import apiContribuinte from '@/modules/atendimento/cadastro/contribuinte/service/contribuinte.service';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = this.initialState;
  }

  get initialState() {
    return {
      Contador: {
        Id: undefined,
        CgcCpf: undefined,
        Nome: undefined,
        Email: undefined,
        Telefone: undefined,
        RgInscricaoEstadual: undefined,
        Endereco: {
          Cep: undefined,
          Cidade: undefined,
          Bairro: undefined,
          Complemento: undefined,
          UF: undefined,
          Id: undefined,
          Logradouro: undefined,
          Numero: undefined,
          Tipo: undefined,
        },
      }
    };
  }

  async handleCgcCpf(value){
    const { props, state, initialState } = this;
    const { onChange } =  props;

    const cpfCnpj = value.replace(/[^\d]+/g, '');
    let contador = state.Contador;

    if (contador.CgcCpf == value)
      return;

    if (!cpfCnpj){
      onChange(initialState.Contador);
    }

    if (!CpfCnpjValidator.validarCPF(cpfCnpj) && !CpfCnpjValidator.validarCNPJ(cpfCnpj)) {
      await _alert.warningPromise('CPF/CNPJ Inválido.');
      return;
    }
    const result = await apiContribuinte.GetByCgcCpf(cpfCnpj);

    if(result?.data)
      onChange(result.data)
    else
      onChange(initialState.Contador)

    this.setState({ Contador: {...state.Contador, CgcCpf: value } });
    onChange({CgcCpf: value})
  }

  handleEndereco(value){
    const { props } = this;
    const { onChange, state } =  props;

    let endereco = _.assign({ ...state.Endereco }, { ...value });
    let contador = { ...this.state.Contador, Endereco: endereco };
    this.setState({ Contador: contador });
    onChange({Endereco: endereco});
  }

  render() {
    const { Campos, Titulo } = DDados;
    const { props } = this;
    const { onChange, state } = props;
    return (
    <>
      <Panel title="Dados da Pessoa">
        <Row>
          <DDadosItem name="Id" {...Campos.Id} />
          <Col lg={4}>
            <DDadosItem
              name="CgcCpf"
              {...Campos.CgcCpf}
              onBlur={value => this.handleCgcCpf(value)}
            />
          </Col>
          <Col lg={8}>
            <DDadosItem
              name="Email"
              {...Campos.Email}
              state={state}
              onChange={value => onChange({Email: value})}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <DDadosItem
              name="Nome"
              {...Campos.Nome}
              state={state}
              onChange={value => onChange({Nome: value})}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <DDadosItem
              name="Telefone"
              {...Campos.Telefone}
              state={state}
              onBlur={value => onChange({Telefone: value})}
            />
          </Col>
          <Col lg={4}>
            <DDadosItem
              name="RgInscricaoEstadual"
              {...Campos.RgInscricaoEstadual}
              state={state}
              onBlur={value => onChange({RgInscricaoEstadual: value})}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Panel title={'Endereço'}>
              <Address
                name="Endereco"
                requireAll={true}
                editavel={false}
                state={state.Endereco}
                onChange={this.handleEndereco}
              />
            </Panel>
          </Col>
        </Row>
      </Panel>
    </>
    );
  }
}

export default connect({
  actions: {
    contadorActions,
  },
  selectors: {
    contadorSelector
  }
})(Container);
